import React from "react";
import cn from 'classnames';

import Input from "../../utilities/element/Input";
import Dropdown from "../../utilities/element/Dropdown";
import Checkbox from "../../utilities/element/Checkbox";
import DateInput from "../../utilities/element/DateInput";
import Salutations from "../../utilities/assets/salutation.json";
import { utilityFns } from "../../utilities/utility-functions";

import "./about-you.scss";

const AboutYouStep = ({ fromAgreement = false, localState, setLocalState }) => {
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "pep") {
      setLocalState({
        ...localState,
        profile: {
          ...localState.profile,
          pep: { ...localState.profile.pep, [name]: checked },
          pepcomment: "",
        },
      });
      return;
    }

    if (name === "citizenship" && !!!localState.profile.address.country) {
      setLocalState({
        ...localState,
        profile: {
          ...localState.profile,
          personal: { ...localState.profile.personal, [name]: value },
          address: { ...localState.profile.address, country: value },
        },
      });
      return;
    }

    if (["firstName", "lastName", "middleName", "title"].includes(name)) {
      setLocalState({
        ...localState,
        profile: {
          ...localState.profile,
          personal: { ...localState.profile.personal, [name]: value },
        },
      });
    } else if (
      ["street", "street2", "city", "postalCode", "country"].includes(name)
    ) {
      setLocalState({
        ...localState,
        profile: {
          ...localState.profile,
          address: { ...localState.profile.address, [name]: value },
        },
      });
    } else {
      setLocalState({
        ...localState,
        profile: { ...localState.profile, [name]: value },
      });
    }
  };

  const { profile } = localState;
  const { personal, address, pep } = profile;
  const countries = localState?.rates?.countries || [];

  const messageForInvalidFields =
    "Use only Latin letters, dots, apostrophes and space between words";

  const messageForInvalidPhone =
    "Use only digits, dashes, and space between characters";

  const checkIfNotValidDateOfBirth =
    (profile.dateofbirth !== undefined &&
      new Date("1903", "01", "01").getTime() - 31 * 86400 * 1000 >
        new Date(profile.dateofbirth).getTime()) ||
    (profile.dateofbirth !== undefined &&
      !(
        new Date().getTime() - (365 * 18 + 5) * 86400 * 1000 >
        new Date(profile.dateofbirth).getTime()
      ));

  const getCitizenshipValue = (citizenship) => {
    if (!citizenship) return "";
    const country = countries.find(
      (c) => c.value === citizenship || c.text === citizenship
    );
    return country ? country.value : "";
  };

  return (
    <div className={cn("about-you-container", { "agreement-container": fromAgreement })}>
      {!fromAgreement && <h4 id="aboutyou">About You</h4>}
      <Dropdown
        name="title"
        label="Title"
        placeholder="Select"
        isgreyed={fromAgreement.toString()}
        value={personal?.title || ""}
        options={Salutations.map((s) => ({
          value: s.value,
          text: s.value,
        }))}
        onChange={handleChange}
        required
      />
      <Input
        name="firstName"
        label="First name"
        placeholder="Required"
        isgreyed={fromAgreement.toString()}
        value={personal?.firstName || ""}
        messagefornotvalid={messageForInvalidFields}
        onChange={handleChange}
        maxLength="40"
        required
        onValidate={utilityFns.validEnglishTextAndNumber}
      />
      <Input
        name="middleName"
        label="Middle name"
        isgreyed={fromAgreement.toString()}
        value={personal?.middleName || ""}
        messagefornotvalid={messageForInvalidFields}
        onChange={handleChange}
        maxLength="40"
        required
        onValidate={utilityFns.validEnglishTextAndNumber}
      />
      <Input
        name="lastName"
        label="Last name"
        placeholder="Required"
        isgreyed={fromAgreement.toString()}
        value={personal?.lastName || ""}
        messagefornotvalid={messageForInvalidFields}
        onChange={handleChange}
        maxLength="40"
        required
        onValidate={utilityFns.validEnglishTextAndNumber}
      />
      <DateInput
        formnotvalid={
          checkIfNotValidDateOfBirth ? checkIfNotValidDateOfBirth : undefined
        }
        messagefornotvalid="Please select a valid age to proceed with registration."
        label="Date of birth"
        name="dateofbirth"
        isgreyed={fromAgreement.toString()}
        value={profile?.dateofbirth?.split("T")[0] || ""}
        onChange={handleChange}
        max={
          new Date(new Date().getTime() + 50 * 365 * 86400 * 1000)
            .toLocaleString("sv")
            .split(" ")[0]
        }
        required
      />
      <Dropdown
        label="Citizenship"
        name="citizenship"
        isgreyed={fromAgreement.toString()}
        value={getCitizenshipValue(personal?.citizenship)}
        placeholder="Select country"
        options={countries.map((s) => ({
          value: s.value,
          text: s.text,
        }))}
        onChange={handleChange}
        required
      />
      {fromAgreement ? (
        <>
        <Input
          name="pep"
          label="Politically Exposed Person"
          placeholder="is pep"
          isgreyed={fromAgreement.toString()}
          value={pep.pep ? "Yes" : "No"}
          onChange={handleChange}
          maxLength="500"
          onValidate={utilityFns.validEnglishText}
        />
        {pep.pep && (
          <Input
            name="details"
            label="Politically Exposed Person Details"
            placeholder="PEP comment"
            isgreyed={fromAgreement.toString()}
            value={pep?.details || ""}
          />
        )}
        </>
      ) : (
        <div>
          <Checkbox
            name="pep"
            placeholder="I am Politically Exposed Person"
            isgreyed={fromAgreement.toString()}
            // tooltip={<TooltipComponent tooltipText={tooltipText} tooltipClassName="tooltip-item"/>}
            value={pep?.pep || false}
            onChange={handleChange}
          />
          <Input
            name="details"
            placeholder="PEP comment"
            disabled={!pep.pep}
            isgreyed={fromAgreement.toString()}
            value={pep?.details || ""}
            onChange={handleChange}
            maxLength="500"
            onValidate={utilityFns.validEnglishText}
          />
        </div>
      )}
      {!fromAgreement && <h4>Contact Information</h4>}
      <Input
        label="Phone Number (Including country code)"
        placeholder="Required"
        name="phone"
        messagefornotvalid={messageForInvalidPhone}
        onValidate={utilityFns.phoneNumber}
        isgreyed={fromAgreement.toString()}
        value={profile?.phone}
        onChange={handleChange}
        maxLength="40"
        required
      />
      <Input
        label="Street Address"
        placeholder="Required"
        isgreyed={fromAgreement.toString()}
        name="street"
        value={address?.street || ""}
        onChange={handleChange}
        maxLength="255"
        required
      />
      <Input
        label="Street Address (additional)"
        isgreyed={fromAgreement.toString()}
        name="street2"
        value={address?.street2 || ""}
        onChange={handleChange}
        maxLength="255"
        required
      />
      <Input
        label="City"
        placeholder="Required"
        isgreyed={fromAgreement.toString()}
        name="city"
        value={address?.city || ""}
        messagefornotvalid={messageForInvalidFields}
        onChange={handleChange}
        required
        onValidate={utilityFns.validEnglishText}
        maxLength="40"
      />
      <Input
        label="Zip/Postal code"
        isgreyed={fromAgreement.toString()}
        name="postalCode"
        value={address?.postalCode || ""}
        onChange={handleChange}
        maxLength="16"
      />
      <Dropdown
        label="Country"
        value={getCitizenshipValue(address?.country) || ""}
        isgreyed={fromAgreement.toString()}
        name="country"
        placeholder="Select country"
        options={countries.map((s) => ({
          value: s.value,
          text: s.text,
        }))}
        onChange={handleChange}
        required
      />
    </div>
  );
};

export default AboutYouStep;
